//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  import { SubmittingEntityIdentifierModel } from "./SubmittingEntityIdentifierModel";
  
  
  export class AddSubmittingEntityModel extends ModelBase {
      static readonly $typeName = 'AddSubmittingEntityModel';
      public name: string;
      public identifier: SubmittingEntityIdentifierModel;
     
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/AddSubmittingEntityModel.ts